{
  "anotherProject": "of another project",
  "appOutdated": {
    "message": "Reload the page to continue with the new version.",
    "title": "DMW was updated"
  },
  "definition": {
    "invalid": "This value isn't valid here.",
    "missing": "Required.",
    "string_pattern_mismatch": "Invalid format.",
    "string_too_long_one": "At most {{count}} character.",
    "string_too_long_other": "At most {{count}} characters.",
    "string_too_short_one": "Must not be empty.",
    "string_too_short_other": "At least {{count}} characters.",
    "too_long_one": "At most one entry.",
    "too_long_other": "At most {{count}} entries.",
    "too_short_one": "At least one entry.",
    "too_short_other": "At least {{count}} entries."
  },
  "details": "Technical details",
  "invalidAddress": {
    "message": "“{{address}}” does not name a page or an item of DMW. Check the link, or use the sections above.",
    "title": "Nothing to open at this address"
  },
  "problem": {
    "acceptance_blocked_by_checks": {
      "message": "This result fails its checks, or they could not run, so it cannot be accepted yet. The details name the statement and why. Correct it, try again later, or reject it.",
      "title": "Its checks block acceptance"
    },
    "account_disabled": {
      "message": "An administrator has disabled this account. Ask them if you need access again.",
      "title": "This account is disabled"
    },
    "account_pending": {
      "message": "Confirm your email address with the link we sent, or wait until an administrator approves your account.",
      "title": "Account not active yet"
    },
    "agent_failed": {
      "message": "The agent stopped with an error. The details say what it reported.",
      "title": "The agent failed"
    },
    "agent_session_unavailable": {
      "message": "The agent's session on the PC this Run runs on is gone. The turn runs again in a fresh session; nothing was paid.",
      "title": "Agent session ended"
    },
    "agent_unavailable": {
      "message": "The chosen agent is not installed, not logged in or not working on the PC this Run runs on.",
      "title": "Agent not available"
    },
    "authentication_required": {
      "message": "Your session has ended or you are not signed in. Sign in and try again.",
      "title": "Please sign in"
    },
    "capability_mismatch": {
      "message": "The chosen LLM lacks what the step needs. Choose another agent or LLM for this Run.",
      "title": "The LLM cannot do this step"
    },
    "configuration_invalid": {
      "message": "Its configuration has an error. Please tell the person who runs this DMW installation.",
      "title": "The server is set up incorrectly"
    },
    "connector_busy": {
      "message": "The DMW Connector runs as many turns as it may. The turn is sent again when one finishes.",
      "title": "DMW Connector busy"
    },
    "connector_limit_reached": {
      "message": "Your account has as many active DMW Connectors as it may have. Revoke one you no longer use under Profile → Connect this PC, then approve again.",
      "title": "Too many DMW Connectors"
    },
    "connector_lost": {
      "message": "The DMW Connector stopped answering during the turn. The turn may have reached the provider, so it is not repeated by itself.",
      "title": "DMW Connector lost"
    },
    "connector_offline": {
      "message": "That DMW Connector is not running. Start it on your PC, then try again.",
      "title": "DMW Connector offline"
    },
    "connector_revoked": {
      "message": "That PC can no longer run steps. Connect it again on the Connect this PC page, or let another PC run this Run.",
      "title": "This PC's DMW Connector was revoked"
    },
    "content_limit_exceeded": {
      "message": "This is larger than the server allows. Split it into smaller parts, or ask the person who runs DMW to raise the limit.",
      "title": "Too large"
    },
    "content_store_failed": {
      "message": "The server could not write to its content store. Nothing was changed. Try again; if it keeps happening, please report it.",
      "title": "The content could not be saved"
    },
    "content_version_conflict": {
      "message": "A newer version exists than the one you started from. Reload, check the latest version and try again.",
      "title": "Someone changed this in the meantime"
    },
    "context_limit_exceeded": {
      "message": "The step's input is larger than the LLM can take. Narrow the step's input or choose an LLM with a larger context.",
      "title": "Too much input"
    },
    "corpus_import_invalid": {
      "message": "Each line must be one JSON object with a key and a text, and keys must be unique. The explanation below names the line.",
      "title": "The import file was not accepted"
    },
    "csrf_token_invalid": {
      "message": "Your session may have changed in another tab. Reload the page and try again.",
      "title": "The request was not accepted"
    },
    "dataset_checks_failed": {
      "message": "The selected results do not pass their checks as one data release. The report below says which result failed, against which content version, and why.",
      "title": "Release checks failed"
    },
    "dataset_member_invalid": {
      "message": "Choose one revision per lineage, using only accepted results of this project.",
      "title": "Not a member"
    },
    "dataset_version_conflict": {
      "message": "Someone created a version of this dataset meanwhile. Reload it and try again.",
      "title": "Another version came first"
    },
    "dataset_version_unchecked": {
      "message": "This version was not checked as a whole, so it cannot be published to ResearchSpace. Create a new version of the same results to check them.",
      "title": "Version not checked"
    },
    "definition_invalid": {
      "message": "The process schema, step or prompt does not fit its format. The details say what to fix.",
      "title": "Definition not valid"
    },
    "dependency_unavailable": {
      "message": "This is usually temporary. Wait a moment and try again.",
      "title": "A service DMW needs is not available right now"
    },
    "email_link_conflict": {
      "message": "Something else changed this account while the link was being used. The link still works: try it again.",
      "title": "The account changed meanwhile"
    },
    "email_link_invalid": {
      "message": "The link is incomplete, was used already, was replaced by a newer one, or has expired. Ask for a new one.",
      "title": "This link does not work"
    },
    "export_target_failed": {
      "message": "The publishing target refused the data or could not be reached. Publishing is recorded as failed; try again.",
      "title": "The target did not take the data"
    },
    "first_administrator_setup_closed": {
      "message": "This installation has its first administrator already, or no setup token is configured. Sign in instead.",
      "title": "Setup is closed"
    },
    "group_order_conflict": {
      "message": "Someone else changed the order meanwhile. The list shows it now; move the group again.",
      "title": "The order changed meanwhile"
    },
    "idempotency_key_conflict": {
      "message": "This action was already sent with other content. Reload the Run and do it again.",
      "title": "Sent twice with changes"
    },
    "illegal_state_transition": {
      "message": "The item has changed since you opened it. Reload it to see its current state.",
      "title": "This step is not possible right now"
    },
    "internal_error": {
      "message": "Nothing you did caused this. Try again; if it keeps happening, please report it.",
      "title": "The server ran into an error"
    },
    "invalid_credentials": {
      "message": "The email address, the password or the token is not correct.",
      "title": "Sign-in failed"
    },
    "invalid_fork_point": {
      "message": "A fork cannot start inside a running turn. Fork at a message or at a finished result.",
      "title": "Cannot fork here"
    },
    "invalid_identifier": {
      "message": "The link or input contains an ID in a form DMW does not use. Check it and try again.",
      "title": "This ID is not valid"
    },
    "invalid_value": {
      "message": "One of the values does not meet the server's rules. Correct it and try again.",
      "title": "A value was not accepted"
    },
    "invalid_version_reference": {
      "message": "A version is written as ID@version. Check the link or input and try again.",
      "title": "This version reference is not valid"
    },
    "item_tools_denied": {
      "message": "Either its owner declined this tool there, or that PC's profile doesn't let tools run. Only the PC's owner can change it: on that PC's approval page, or in its DMW Connector settings. The DMW Connector's reason is below.",
      "title": "That PC doesn't let this tool run"
    },
    "last_administrator": {
      "message": "The installation needs at least one active administrator. Add someone else to Administrators first.",
      "title": "The last administrator must stay"
    },
    "last_project_administrator": {
      "message": "Every project's Administrators need at least one active member. Add someone else to them first.",
      "title": "The last project administrator must stay"
    },
    "maintained_item_edited": {
      "message": "This item is built from other items and kept up to date. Change what it is built from, or stop keeping it up to date.",
      "title": "This item is kept up to date"
    },
    "malformed_request": {
      "message": "The app sent something the server could not read. Reload the page and try again.",
      "title": "The request could not be read"
    },
    "merge_blocked_by_maintained_items": {
      "message": "This change alters what an item that is kept up to date is built from, and the item is not rebuilt yet. It merges once the rebuild is in the change.",
      "title": "Waits for a rebuild"
    },
    "merge_blocked_by_shape_violations": {
      "message": "The checks find shape violations that the version before this change did not have. No acknowledgement merges them: send the change back so its data model or its shapes are revised.",
      "title": "The change adds shape violations"
    },
    "method_not_allowed": {
      "message": "The app and the server may be out of step. Reload the page and try again.",
      "title": "The server does not allow this action"
    },
    "model_unavailable": {
      "message": "The agent or API on the PC this Run runs on does not offer the chosen LLM. That PC's owner can choose another.",
      "title": "LLM not available"
    },
    "ontology_release_checks_failed": {
      "message": "The checks of the data model at this content version did not pass, so its ontology module is not released. The check step's report says which check failed.",
      "title": "Release checks failed"
    },
    "output_invalid": {
      "message": "The result does not fit the step's output format. The details say what is wrong.",
      "title": "Result not valid"
    },
    "permission_denied": {
      "message": "Your permissions do not allow this in this project. Ask a project administrator if you need it.",
      "reasons": {
        "project_access_ended": {
          "message": "The turn ended because the person on whose PC this Run runs may no longer read this project. A project administrator can give the access back.",
          "title": "The person running this Run lost access to this project"
        },
        "rank": {
          "message": "You manage only people and groups below your highest group. Someone whose group ranks higher can do it.",
          "title": "Not below your highest group"
        }
      },
      "title": "Not allowed"
    },
    "permission_profile_unknown": {
      "message": "The DMW Connector of the PC this Run runs on has no permission profile of that name. That PC's owner can choose one it reports.",
      "title": "Unknown permission profile"
    },
    "project_creation_not_allowed": {
      "message": "This installation does not let members create projects. Ask an administrator to create one and add you.",
      "title": "Only administrators create projects here"
    },
    "project_limit_reached": {
      "message": "You have created as many projects as this installation allows. Ask an administrator to create another one for you.",
      "title": "Project limit reached"
    },
    "project_purge_unavailable": {
      "message": "Erasing some of a project's data isn't built yet. The project stays deleted and can be restored.",
      "title": "Purging not available yet"
    },
    "project_restore_period_running": {
      "message": "This project can still be restored. It can be purged once its restore period is over.",
      "title": "Still restorable"
    },
    "provider_authentication_failed": {
      "message": "Add a valid key where this one is kept: for a PC's key, on the Connect this PC page; for a server key, under Server keys in Administration. Then try again.",
      "title": "The provider refused the key"
    },
    "provider_insufficient_credits": {
      "message": "Top up the account at the provider, or let another agent or key run this Run. Then run the step again.",
      "title": "The provider's credit is used up"
    },
    "provider_rate_limited": {
      "message": "The LLM provider asks to slow down. Try again in a moment.",
      "title": "Provider limit reached"
    },
    "provider_request_failed": {
      "message": "The LLM provider answered with an error. The details say what it reported.",
      "title": "Provider request failed"
    },
    "rate_limited": {
      "message": "Wait a few minutes, then try again.",
      "title": "Too many requests"
    },
    "request_validation_failed": {
      "message": "Some values are missing or have the wrong form. Check the input and try again.",
      "title": "The input was not accepted"
    },
    "resource_already_exists": {
      "message": "Something with this name or address exists already. Choose another one, or use the existing one.",
      "title": "It exists already"
    },
    "resource_not_found": {
      "message": "What you asked for does not exist, or not in this version. Check the link or the reference.",
      "reasons": {
        "held_by_library": {
          "message": "Change it in that library.",
          "title": "Belongs to the library <project/>"
        }
      },
      "resourceKinds": {
        "connector": "This DMW Connector does not exist, or it is not yours. Reload the list of DMW Connectors.",
        "device_authorization": "No pairing has this code. Compare it with the code your DMW Connector shows. If the DMW Connector has stopped or restarted, start pairing again on the PC.",
        "entry": "The Run has no entry with this number.",
        "host_offer": "This offer does not exist, or it is not for you. Ask the person whose PC runs the Run to send it again.",
        "ontology_term": "This version of the ontology declares no such term. It may have been added later or removed; choose another version.",
        "thread": "No Run has this ID, or you may not read it. Check the link or the reference.",
        "turn": "This turn does not exist in the Run. Reload the Run."
      },
      "title": "Not found"
    },
    "review_acknowledgement_required": {
      "message": "Checks fail or conflicts are open on this version. Tick the acknowledgement and say why merging is right.",
      "title": "Open findings need your acknowledgement"
    },
    "review_approvals_missing": {
      "message": "Every changed item needs an approval by one of its curators on this version before it can be merged.",
      "title": "Approvals are missing"
    },
    "review_decision_stale": {
      "message": "Someone added to the change set or ran its checks again since you opened it. Reload, look at the new version and decide again.",
      "title": "The change set has changed"
    },
    "route_not_found": {
      "message": "This server has no endpoint for this action. The app may be newer than the server.",
      "title": "The server does not offer this yet"
    },
    "secret_detected": {
      "message": "The text contains something that looks like a key, a token or a password. Remove it and send again; secrets never enter a Run.",
      "title": "Looks like a secret"
    },
    "segmentation_configuration_invalid": {
      "message": "The segmentation configuration has an error. The explanation below says which rule or pattern.",
      "title": "The segmentation was not accepted"
    },
    "self_registration_closed": {
      "message": "This installation creates accounts by invitation only. Ask an administrator.",
      "title": "Registration is closed"
    },
    "skill_server_unavailable": {
      "message": "Run the step again in a moment. If it keeps failing, tell this installation's administrator.",
      "title": "The skills this step needs couldn't be reached"
    },
    "stored_content_invalid": {
      "message": "The server found stored content it cannot read. Please report this with the reference below.",
      "title": "Stored content cannot be read"
    },
    "stored_data_invalid": {
      "message": "DMW will not serve this data, because it no longer matches its recorded digest. Report this to an administrator.",
      "title": "Stored data is damaged"
    },
    "thread_busy": {
      "message": "An agent turn is running or a person step waits for an answer. Wait for the turn or cancel it, or answer the step, and try again.",
      "title": "The Run is busy"
    },
    "thread_log_conflict": {
      "message": "Someone wrote in the Run while you were changing it. Look at the latest entries and try again.",
      "title": "The Run moved on"
    },
    "thread_log_invalid": {
      "message": "The server found entries that do not fit together. Please report this with the request reference.",
      "title": "Run log damaged"
    },
    "thread_not_live": {
      "message": "The DMW Connector of the PC this Run runs on is offline, so only that PC's owner can write now. Fork the Run to continue on your own.",
      "title": "The Run is not connected"
    },
    "tool_call_limit_exceeded": {
      "message": "The agent called tools more often than this turn allows, and was stopped.",
      "title": "Too many tool calls"
    },
    "tool_consent_required": {
      "message": "This version of the tool has not run on the PC this Run runs on before. Its owner approves it in the Run; then the step continues by itself.",
      "title": "Approve this tool"
    },
    "tool_environment_failed": {
      "message": "Check that PC’s internet connection, then run the step again.",
      "title": "The tool couldn't be set up on that PC"
    },
    "tool_failed": {
      "message": "Run the step again once the cause is fixed.",
      "title": "The tool stopped with an error"
    },
    "tool_input_unavailable": {
      "message": "It may be a file on that PC that has moved, or a document the server couldn't send. Details say which; run the step again once it's there.",
      "title": "An input the tool needs isn't available"
    },
    "tool_model_unavailable": {
      "message": "Downloading it to that PC failed. Details say why; run the step again once that's fixed.",
      "title": "The embedding model isn't on that PC yet"
    },
    "tool_not_allowed": {
      "message": "The agent asked for a DMW tool this turn may not use.",
      "title": "Tool not allowed"
    },
    "tool_not_reviewed": {
      "message": "It runs once its change is merged into the project. Ask a curator to review it.",
      "title": "This tool version hasn't been reviewed yet"
    },
    "tool_output_too_large": {
      "message": "Run it on a smaller part of the documents. Details name the limit.",
      "title": "The tool's result is too large"
    },
    "tool_output_upload_failed": {
      "message": "Run the step again. If it keeps failing, check that PC's internet connection. Details say which output.",
      "title": "The tool's result couldn't be sent to DMW"
    },
    "tool_runtime_unavailable": {
      "message": "It needs a newer DMW Connector or the tool's runtime.",
      "reasons": {
        "connector_outdated": {
          "message": "Update the DMW Connector on {{pc}}, then run the step again.",
          "title": "DMW Connector is out of date"
        }
      },
      "title": "That PC can't run this kind of tool"
    },
    "tool_timed_out": {
      "message": "Its own status is below. A stopped tool needs a smaller part of the documents, or more time from the step's author.",
      "title": "The tool ran out of time"
    },
    "turn_interrupted": {
      "message": "The DMW Connector restarted during the turn. It may have reached the provider, so it is not repeated by itself; run it again if needed.",
      "title": "Turn interrupted"
    },
    "turn_timed_out": {
      "message": "The turn ran longer than allowed and was stopped.",
      "title": "Turn took too long"
    },
    "unknown": {
      "message": "The server answered with the code “{{code}}” (HTTP {{status}}), which this version of the app does not know yet.",
      "title": "The server reported a problem"
    },
    "workspace_access_denied": {
      "message": "The PC's owner decides which folders tools may read, in the DMW Connector's settings on that PC.",
      "title": "The tool may not read files on that PC"
    }
  },
  "referenceLabel": "Reference {{requestId}}",
  "reload": "Reload",
  "reportThis": "Report this problem",
  "requestReference": "If you report this, quote the reference {{requestId}}.",
  "retry": "Try again",
  "serverUnreachable": {
    "message": "Check that the DMW server is running and that this computer is online, then try again.",
    "title": "The server does not answer"
  },
  "technicalDetail": "Server explanation: {{detail}}",
  "unexpected": {
    "message": "The error was logged in the browser console. Reload the page; if it happens again, please report it.",
    "title": "Something went wrong in the app"
  },
  "unexpectedResponse": {
    "message": "The server answered (HTTP {{status}}), but not in the form this app expects. The app and the server may be out of step.",
    "title": "The server's answer could not be read"
  }
}
